// Import model
import { GetAddressPredictionsResponse } from '../models/GetAddressPredictionsResponse';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { AddressPrediction } from '../models/AddressPrediction';

// Import dependency serializers (for complex types)
import { AddressPredictionSerializer } from './AddressPredictionSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for GetAddressPredictionsResponse - handles JSON serialization and deserialization with type validation
 */
export class GetAddressPredictionsResponseSerializer {
  /**
   * Deserializes a JSON string into a GetAddressPredictionsResponse instance
   */
  static deserialize(json: string): GetAddressPredictionsResponse {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a GetAddressPredictionsResponse instance
   */
  static fromObject(obj: any): GetAddressPredictionsResponse {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to GetAddressPredictionsResponse');
    }


    const instance: GetAddressPredictionsResponse = {
      predictions: obj['predictions'] ? (obj['predictions'] as any[]).map((item: any) =>
        AddressPredictionSerializer.fromObject(item)
      ) : [] as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of GetAddressPredictionsResponse instances
   */
  static deserializeArray(json: string): GetAddressPredictionsResponse[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a GetAddressPredictionsResponse instance to a JSON string
   */
  static serialize(instance: GetAddressPredictionsResponse): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a GetAddressPredictionsResponse instance to a plain object
   */
  static toObject(instance: GetAddressPredictionsResponse): any {
    return {
      'predictions': instance.predictions?.map((item: any) =>
        AddressPredictionSerializer.toObject(item)
      ),
    };
  }

  /**
   * Serializes an array of GetAddressPredictionsResponse instances to a JSON string
   */
  static serializeArray(instances: GetAddressPredictionsResponse[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
